import React from "react";

function Faqs(){
    return(
        <div className=" flex justify-center items-center m-10">
            <div className=" shadow-xl shadow-black  rounded-md w-[600px]   text-center">
            <p className="font-extrabold lg:text-5xl italic">FAQs</p>
            <p className=" text-justify m-5 mt-10 text-gray-400"> <b className=" text-xl">Who Can Join: </b> Anyone and everyone can join regardless of your major! </p>
            <p className=" text-justify m-5 mt-10 text-gray-400"> <b className=" text-xl">How Long Is The Event: </b> The event will run from Friday 5pm till Saturday 5pm</p>
            <p className=" text-justify m-5 mt-10 text-gray-400"> <b className=" text-xl">Will there be a Workshop: </b> Yes there will be a workshop during different times</p>
            <p className=" text-justify m-5 mt-10 text-gray-400"> <b className=" text-xl">NOTE: </b>  This is a Mock hackathon to prepare for the actual hackathon that will be happening in December</p>

            
            </div>
            
        </div>
    )
}

export default Faqs;